import { render, staticRenderFns } from "./preMsg.vue?vue&type=template&id=51919b3d&scoped=true&"
import script from "./preMsg.vue?vue&type=script&lang=js&"
export * from "./preMsg.vue?vue&type=script&lang=js&"
import style0 from "./preMsg.vue?vue&type=style&index=0&id=51919b3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51919b3d",
  null
  
)

export default component.exports